var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-info-tooltip',{staticClass:"mr-1 d-print-none",attrs:{"text":_vm.getText()}})}
var staticRenderFns = []

export { render, staticRenderFns }